import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { Glyphicon, Button } from 'reaxl';
import PhoneNumber from '../PhoneNumber/index.js';

/**
 *   The PhoneNumberCallAction component will display a phone number
 *   If isCallable (Click To Call), it displays phone number as a hyperlink
 *
 */
function PhoneNumberCallAction(_ref) {
  let {
    className,
    extension,
    isButton = false,
    isCallable = false,
    onCall = () => {},
    phoneNumber,
    showIcon = false,
    ...rest
  } = _ref;
  const phoneGlyph = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "phone",
    className: isButton ? undefined : 'margin-right-2 align-self-center',
    "aria-hidden": !isButton
  });
  const formatPhoneNumber = /*#__PURE__*/React.createElement(React.Fragment, null, showIcon && phoneGlyph, /*#__PURE__*/React.createElement(PhoneNumber, Object.assign({
    className: className,
    phoneNumber: phoneNumber,
    extension: extension
  }, rest)));
  if (isCallable) {
    const props = {
      'data-cmp': 'ownerPhoneNumber',
      href: 'tel:' + phoneNumber,
      rel: 'nofollow',
      onClick: onCall,
      role: 'button'
    };
    if (isButton) {
      props.className = 'display-inline-block';
    } else {
      props.className = 'link-undecorated';
    }
    return /*#__PURE__*/React.createElement(isButton ? Button : 'a', props, isButton ? phoneGlyph : formatPhoneNumber);
  }
  return formatPhoneNumber;
}
export default PhoneNumberCallAction;